export const BASE_HOST = 'localcreators.com/';

/** ALL-CAPS 13 / semibold kicker (Creator link, Top videos, Brands, Packages, …) */
export const LC_SECTION_KICKER = {
  fontSize: '13px',
  lineHeight: '19.5px',
  fontWeight: 600,
  color: '#1c1917',
  letterSpacing: '0.325px',
} as const;

/** Figma: section labels (Profile, Creator link, …) — 11.5 / uppercase / muted */
export const LC_SECTION_HEADER_UPPER = {
  fontSize: '11.5px',
  lineHeight: '17.25px',
  fontWeight: 600,
  color: '#79716b',
  letterSpacing: '0.69px',
} as const;

/** Layout tokens aligned with Figma “How it works” list */
export const HOW_IT_WORKS_FIGMA = {
  rowH: '57.35px',
  icon: '28px',
  iconOffsetTop: '8px',
  lineLeft: '13.5px',
  lineFromIconBottom: '40px',
  lineToRowBottom: '7.98px',
  textLeft: '40px',
  contentPad: { x: '11.55px', t: '7.55px', b: '7.5px' },
} as const;
